import { CommonError } from '../../../types';
import { EventsActions } from './actions';
import { FETCH_EVENTS_FAILURE, FETCH_EVENTS_REQUEST, FETCH_EVENTS_SUCCESS } from './constants';
import { EventsData } from './types';

export interface EventsState {
    eventsData: EventsData[];

    loading: boolean;
    error: CommonError | null;
}
const initialState: EventsState = {
    eventsData: [],
    loading: false,
    error: null,
};
export const StockEventsReducer = (state = initialState, action: EventsActions): EventsState => {
    switch (action.type) {
        case FETCH_EVENTS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_EVENTS_SUCCESS: {
            return { ...state, loading: false, eventsData: action.payload };
        }
        case FETCH_EVENTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
